const mEditionMapTasks = {
  mEditionMapTasks: {
    messages: {
      noCompletedTasks: 'Sin tareas completadas',
      noPendingTasks: 'Sin tareas pendientes'
    },

    quote: {
      firstText: 'Aún no tienes caminos creados en tu mapa.',
      secondText: 'Para interactuar con tus alumnos en la sección de tareas primero debes crear caminos ingresando a'
    }
  }
}

export default mEditionMapTasks
